import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from "firebase/firestore";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, updateEmail, updatePassword, signOut } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA48mVl6plJMFeKZEao4I9_AwhGJait03U",
  authDomain: "rabanot-770.firebaseapp.com",
  projectId: "rabanot-770",
  storageBucket: "rabanot-770.appspot.com",
  messagingSenderId: "124581777140",
  appId: "1:124581777140:web:eb29018eb4ce02d33318a1",
  measurementId: "G-TL9D436MX8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export {
  db,
  auth,
  storage,
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  updateDoc,
  doc,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  updateEmail,
  updatePassword,
  ref,
  uploadBytes,
  getDownloadURL,
};